import script from "./ReportAsistencia.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportAsistencia.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__